module.exports = __webpack_public_path__ + "static/img/banner_3.3ac557a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/hlw/banner_3.png
// module id = hR5m
// module chunks = 1